module.exports = __webpack_public_path__ + "img/users.39885b97.svg";